
{
  "familyId": "GET-BREUK-GEMENGD",
  "questions": [
    {
      "id": "GET-BREUK-GEMENGD-001",
      "familyId": "GET-BREUK-GEMENGD",
      "module": "Getalbegrip",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "breuken",
      "subSkill": "breuk_gemengd",
      "questionType": "multiple_choice",
      "question": "Schrijf ⁷⁄₃ als gemengd getal.",
      "options": [
        "2⅓",
        "1⅓",
        "2⅔",
        "3½"
      ],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [],
      "conceptId": "breuk_naar_gemengd",
      "variantIndex": 1,
      "citoDifficulty": 0.36,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "Strategie: deel de teller door de noemer. Stap 1: 7 ÷ 3 = 2 rest 1. Stap 2: Het hele getal = 2 (het quotiënt). Stap 3: De rest = 1 → breukdeel = ⅓. Stap 4: ⁷⁄₃ = 2⅓. Controleer: 2 × 3 + 1 = 7 ✓.",
        "distractorExplanations": {
          "0": "Goed! 7 ÷ 3 = 2 rest 1, dus ⁷⁄₃ = 2⅓.",
          "1": "Veelgemaakte fout: verkeerd delen. 7 ÷ 3 = 2 rest 1, niet 1 rest 1. 3 past 2 keer in 7 (3 × 2 = 6), niet 1 keer.",
          "2": "Veelgemaakte fout: de rest verkeerd bepalen. 7 − 6 = 1 (rest), niet 2. Dus het breukdeel is ⅓, niet ⅔.",
          "3": "Veelgemaakte fout: de noemer verwarren. ⁷⁄₃ heeft noemer 3, niet 2. 3½ = ⁷⁄₂, niet ⁷⁄₃."
        }
      }
    },
    {
      "id": "GET-BREUK-GEMENGD-002",
      "familyId": "GET-BREUK-GEMENGD",
      "module": "Getalbegrip",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "breuken",
      "subSkill": "breuk_gemengd",
      "questionType": "multiple_choice",
      "question": "Schrijf 3¼ als onechte breuk.",
      "options": [
        "¹³⁄₄",
        "¹²⁄₄",
        "⁷⁄₄",
        "³¹⁄₄"
      ],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [],
      "conceptId": "gemengd_naar_breuk",
      "variantIndex": 2,
      "citoDifficulty": 0.34,
      "citoDiscrimination": 0.73,
      "feedback": {
        "explanationText": "Strategie: vermenigvuldig het hele getal met de noemer en tel de teller erbij op. Stap 1: Heel getal × noemer: 3 × 4 = 12. Stap 2: Tel de teller erbij: 12 + 1 = 13. Stap 3: De noemer blijft 4. Stap 4: 3¼ = ¹³⁄₄.",
        "distractorExplanations": {
          "0": "Goed! 3 × 4 + 1 = 13, dus 3¼ = ¹³⁄₄.",
          "1": "Veelgemaakte fout: de teller vergeten op te tellen. 3 × 4 = 12, maar je moet de teller (1) er nog bij optellen: 12 + 1 = 13.",
          "2": "Veelgemaakte fout: het hele getal niet vermenigvuldigen met de noemer. 3 + 4 = 7, maar de formule is: heel × noemer + teller = 3 × 4 + 1 = 13.",
          "3": "Veelgemaakte fout: de cijfers achter elkaar schrijven. 3¼ is niet 31 vierde. De formule is: 3 × 4 + 1 = 13 → ¹³⁄₄."
        }
      }
    },
    {
      "id": "GET-BREUK-GEMENGD-003",
      "familyId": "GET-BREUK-GEMENGD",
      "module": "Getalbegrip",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "breuken",
      "subSkill": "breuk_gemengd",
      "questionType": "multiple_choice",
      "question": "Wat is 1¾ + 2½?",
      "options": [
        "4¼",
        "3¾",
        "3⁵⁄₆",
        "4¾"
      ],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [],
      "conceptId": "gemengd_optellen",
      "variantIndex": 3,
      "citoDifficulty": 0.44,
      "citoDiscrimination": 0.69,
      "feedback": {
        "explanationText": "Strategie: tel de hele getallen en de breuken apart op. Stap 1: Hele getallen: 1 + 2 = 3. Stap 2: Breuken gelijknamig maken: ¾ + ½ = ¾ + ²⁄₄ = ⁵⁄₄. Stap 3: ⁵⁄₄ = 1¼ (onechte breuk → gemengd). Stap 4: 3 + 1¼ = 4¼.",
        "distractorExplanations": {
          "0": "Goed! 1¾ + 2½ = 3 + ¾ + ²⁄₄ = 3 + ⁵⁄₄ = 3 + 1¼ = 4¼.",
          "1": "Veelgemaakte fout: de overdracht van de breuken vergeten. ¾ + ½ = ⁵⁄₄ = 1¼. Die extra 1 moet bij de hele getallen: 3 + 1 = 4.",
          "2": "Veelgemaakte fout: de noemers optellen. ¾ + ½ ≠ ⁵⁄₆. Je moet de breuken eerst gelijknamig maken: ¾ + ²⁄₄ = ⁵⁄₄.",
          "3": "Veelgemaakte fout: de breuken verkeerd optellen. ¾ + ½ = ¾ + ²⁄₄ = ⁵⁄₄ = 1¼, niet ¾. Het antwoord is 4¼, niet 4¾."
        }
      }
    },
    {
      "id": "GET-BREUK-GEMENGD-004",
      "familyId": "GET-BREUK-GEMENGD",
      "module": "Getalbegrip",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "breuken",
      "subSkill": "breuk_gemengd",
      "questionType": "multiple_choice",
      "question": "Welk gemengd getal is gelijk aan 2,75?",
      "options": [
        "2¾",
        "2⅞",
        "2⁷⁄₁₀",
        "2½"
      ],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [],
      "conceptId": "gemengd_decimaal_koppeling",
      "variantIndex": 4,
      "citoDifficulty": 0.38,
      "citoDiscrimination": 0.71,
      "feedback": {
        "explanationText": "Strategie: zet het decimale deel om naar een breuk. Stap 1: 2,75 = 2 + 0,75. Stap 2: 0,75 = 75/100. Stap 3: Vereenvoudig: 75/100 ÷ 25/25 = ¾. Stap 4: 2,75 = 2¾.",
        "distractorExplanations": {
          "0": "Goed! 2,75 = 2¾. Want 0,75 = 75/100 = ¾.",
          "1": "⅞ = 0,875, niet 0,75. 2⅞ = 2,875, dat is meer dan 2,75.",
          "2": "⁷⁄₁₀ = 0,7, niet 0,75. 2⁷⁄₁₀ = 2,7, dat is minder dan 2,75.",
          "3": "½ = 0,5, niet 0,75. 2½ = 2,5, dat is minder dan 2,75."
        }
      }
    }
  ]
}
